import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import styled from 'styled-components'
import { colors } from '~/design'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;

  img {
    width: 100%;
    height: 165px;
    object-fit: cover;
  }

  .text {
    padding: 15px;
  }

  .bottom {
    display: flex;
    justify-content: flex-end;
    padding: 10px 15px 15px;

    a {
      display: flex;
      align-items: center;
      gap: 5px;
      font-weight: bold;
      padding: 2px 8px;
      background: ${colors.sebraeBlue};
      color: #fff;
      border-radius: 10px;
      transition: transform 0.2s ease-in-out;

      &:hover {
        transform: scale(1.05);
      }
    }
  }
`

export default function StudyGridItemSubnormalClusters() {
  return (
    <Wrapper>
      <div>
        <img
          src='https://images.unsplash.com/photo-1551717256-ad2ac9ab0261?blend=000000&blend-alpha=10&blend-mode=normal&blend-w=1&crop=faces%2Cedges&h=630&mark=https%3A%2F%2Fimages.unsplash.com%2Fopengraph%2Flogo.png&mark-align=top%2Cleft&mark-pad=50&mark-w=64&w=1200&auto=format&fit=crop&q=60&ixid=M3wxMjA3fDB8MXxhbGx8fHx8fHx8fHwxNzEwNTM2Mzk0fA&ixlib=rb-4.0.3'
          alt='Imagem Exemplo'
        />
        <div className='text'>
          <span>
            Um estudo sobre alguns aglomerados subnormais do Brasil, seus estabelecimentos e
            atendimentos pelo SEBRAE.
          </span>
        </div>
      </div>
      <div className='bottom'>
        <a href={'/app/report/subnormal-clusters'}>
          ver mais
          <FontAwesomeIcon icon={faArrowRight} color='#fff' />
        </a>
      </div>
    </Wrapper>
  )
}
